export const KAMBI = 'kambi';

export const KAMBI_DEFAULT_LOCALE = 'en_US';

export const KAMBI_DEFAULT_LOCALE_MAP = [];
